module.exports = __webpack_public_path__ + "img/qke_liushui.db1ccce8.gif";